import React from 'react';
import './index.css';

const Footer = () => {
    return (
        <>
            <div className="outter"></div>
            <div className="inner">with 3LO Gdynia</div>
        </>)
}

export default Footer;